/**
 * Gets trusted form fields
 * @param {string} id - The form id
 * @returns {{
 *  xxTrustedFormCertUrl: string,
 *  xxTrustedFormPingUrl: string,
 *  xxTrustedFormToken: string
 * }} - An object containing the trusted form fields
 */
export function getTrustedFormFields(id) {
  const trustedForm = /** @type {HTMLFormElement} */ (
    document.getElementById(id)
  )
  if (!trustedForm) {
    throw Error('unexpected: trusted form element missing')
  }

  const trustedFormData = new FormData(trustedForm)
  const xxTrustedFormCertUrl =
    trustedFormData.get('xxTrustedFormCertUrl')?.toString() || ''
  const xxTrustedFormPingUrl =
    trustedFormData.get('xxTrustedFormPingUrl')?.toString() || ''
  const xxTrustedFormToken =
    trustedFormData.get('xxTrustedFormToken')?.toString() || ''

  return {
    xxTrustedFormCertUrl,
    xxTrustedFormPingUrl,
    xxTrustedFormToken,
  }
}
